exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".example-problem{width:90%;margin:0 auto;border-bottom:2px solid #d3dce6}.example-problem-main{width:95%;margin:20px auto}.remain{font-size:16px;position:relative}.remain-icon{position:absolute;right:-16px;top:-1px}.example-problem-main h2{font-size:24px}.example-problem-main p{font-size:16px;color:#5e6d82;margin:10px 0 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1132b5f3","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Services/tabs/services_mogos.vue
// module id = 341
// module chunks = 0